import React from 'react'
import { makeStyles, Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   mainButton: {
      color: '#FFF'
   },
   addMargin: {
      margin: theme.spacing(2, 0, 1, 0)
   }
}))

function MainButton({ text, onClick = () => {}, addMargin = true }) {
   const classes = useStyles()

   return (
      <Button
         color="primary"
         className={`${classes.mainButton} ${addMargin && classes.addMargin}`}
         disableElevation
         fullWidth
         onClick={onClick}
         variant="contained"
      >
         {text}
      </Button>
   )
}

export default MainButton
